import { render, staticRenderFns } from "./shiftDialog.vue?vue&type=template&id=1852cbc8&scoped=true"
import script from "./shiftDialog.vue?vue&type=script&lang=js"
export * from "./shiftDialog.vue?vue&type=script&lang=js"
import style0 from "./shiftDialog.vue?vue&type=style&index=0&id=1852cbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852cbc8",
  null
  
)

export default component.exports